import * as React from 'react';
import { observer } from 'mobx-react';
import { themeStore } from '@GlobalStores';
import { MoonIcon } from './MoonIcon';
import { SunIcon } from './SunIcon';
import './theme-toggle.scss';

type ThemeToggleProps = {
    className?: string;
};

@observer
export class ThemeToggle extends React.PureComponent<ThemeToggleProps> {
    public render() {
        const { className } = this.props;
        const cls = ['theme-toggle'];
        if (className) cls.push(className);
        const isDark = themeStore.theme === 'dark';

        return (
            <div className={cls.join(' ')}>
                {isDark
                    ? <SunIcon className="icon theme-icon theme-icon-light" title="Switch to light mode" size={14} onClick={themeStore.toggleTheme} />
                    : <MoonIcon className="icon theme-icon theme-icon-dark" title="Switch to dark mode" size={14} onClick={themeStore.toggleTheme} />}
            </div>
        );
    }
}
